/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useState } from "react";
import { useContext } from "../../../context";
import { AVAILABLE_BUTTONS } from "../../../../../../../../../api/appointments/useAppointmentQuery";
import { useUpdateProvider } from "../../../hooks/useUpdateProvider";
import { uiNotification } from "../../../../../../../../../services/UINotificationService";

export function MedicalProvider() {
  const { appointment, selectedProvider, selectedAdditionalProvider } =
    useContext();
  const updateProvider = useUpdateProvider();

  const [showEditProvider, setShowEditProvider] = useState(false);

  const onUpdateProvider = () => {
    if (!selectedProvider.value) {
      return uiNotification.error("Please select a provider.");
    }
    if (updateProvider.isLoading) {
      return;
    }
    updateProvider
      .initiate({
        providerId: Number(selectedProvider.value),
      })
      .then(() => {
        setShowEditProvider(false);
        selectedProvider.setValue(0);
      });
  };

  return (
    <>
      <div className="detail-row">
        <label>Medical Provider:</label>
        <span className="editEventCalNote">
          {!showEditProvider &&
          appointment.additionalProvider &&
          !appointment.isMainProvider
            ? appointment.additionalProvider.name
            : appointment.provider.name}

          {showEditProvider && (
            <select
              className="simpleSelect"
              name="appointment_provider"
              onChange={(e) =>
                selectedProvider.setValue(Number(e.target.value))
              }
              value={selectedProvider.value}
            >
              <option value="0">Select</option>
              {appointment.providersForChange
                .filter(
                  (x) =>
                    String(x.id) !== String(selectedAdditionalProvider.value),
                )
                .map((obj, idx) => (
                  <option key={idx} value={obj.id}>
                    {obj.fullName}
                  </option>
                ))}
            </select>
          )}

          {appointment.availableButtons.includes(
            AVAILABLE_BUTTONS.cancelAppointment,
          ) &&
            !appointment.isAdditionalProviderAppointment && (
              <a onClick={() => setShowEditProvider(true)}>
                <i className="far fa-edit"></i>
              </a>
            )}
        </span>
      </div>
      {showEditProvider && (
        <div className="deatil-row appointNoteBtn d-flex justify-end">
          <span>
            <button
              className="new-white-btn no-width"
              onClick={() => {
                setShowEditProvider(false);
              }}
            >
              Cancel
            </button>
            <button
              className="new-blue-btn no-width"
              onClick={onUpdateProvider}
              disabled={updateProvider.isLoading || !selectedProvider.value}
            >
              {updateProvider.isLoading ? "Saving..." : "Save"}
            </button>
          </span>
        </div>
      )}
    </>
  );
}
